// extracted by mini-css-extract-plugin
export default {"wrapper":"Guides_wrapper__OUPLK","title":"Guides_title__IJ+eZ","iFrame":"Guides_iFrame__pMXxL"};